import { compose } from "redux";

import DetailedGHRProvider from "./Detailed";
import Default from "./Default";
import Error from "../Error";
import withContainer from "../common/hoc/WithContainer";
import injectLayoutWithQuickLinks from "../InjectLayoutWithQuickLinks";
import extractId from "../ExtractId";

import { getObjectById } from "../../services/MODSService";

const type = "GHRProvider";
export default compose(
    extractId(),
    withContainer({
        dataParams: {
            fetchHandler: getObjectById
        },
        defaultLoadingMessage: "Loading GHR Operator",
        Error,
        DefaultComponent: Default
    }),
    injectLayoutWithQuickLinks(type)
)(DetailedGHRProvider);
